import { IRootState } from '../../../store'
import { ISceneDescriptionOptionsState } from '../store/options.types'

export const getSceneDescriptionOptionsSelector = (state: IRootState): ISceneDescriptionOptionsState =>
  state.options.sceneDescriptionOptions
